const transformScrumStatusData = (rawData) => {
  const colorMap = {};
  const transformedData = rawData.map(entry => {
    const transformed = { date: entry.date };
    entry.statusCounts.forEach(status => {
      transformed[status.name] = status.count;
      if (!colorMap[status.name] && status.color) {
        colorMap[status.name] = status.color;
      }
    });
    return transformed;
  });

  return { data: transformedData, colorMap };
};

const ScrumVelocityChart = (rawData = []) => {
  const { data, colorMap } = transformScrumStatusData(rawData);
  const useDataZoom = data.length > 6;

  const dates = data.map(entry => entry.date);

  const statusList = Object.keys(data[0] || {}).filter(k => k !== 'date');

  const series = statusList.map(status => ({
    name: capitalize(status),
    type: 'bar',
    data: data.map(entry => entry[status] ?? 0),
    itemStyle: {
      borderRadius: [4, 4, 0, 0],
      color: colorMap[status] || getFallbackColor(status)
    },
    label: {
      show: true,
      position: 'top',
      formatter: '{c}', // shows count (value)
      color: '#000',     // or any theme-matching color
      fontSize: 12
    }
  }));

  return {
    tooltip: { trigger: 'axis' },
    legend: { show: false },
    grid: {
      left: 0,
      right: 0,
      bottom: useDataZoom ? 35 : 35,
      top: 40,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: dates,
      axisLabel: {
        formatter: value =>
          new Date(value).toLocaleDateString('en-IN', {
            month: 'short',
            day: 'numeric'
          })
      }
    },
    yAxis: { type: 'value' },
    dataZoom: useDataZoom
      ? [
        {
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 40
        },
        {
          type: 'slider',
          show: false,
          start: 0,
          end: 40,
          xAxisIndex: 0,
          height: 15,
          bottom: 40
        }
      ]
      : [],
    series
  };
};

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function getFallbackColor(key) {
  const fallbackColors = [
    '#FF6B6B', '#6BCB77', '#4D96FF', '#F7B801', '#9D4EDD',
    '#00A8E8', '#F95738', '#3A506B', '#2D3142', '#EA7317'
  ];
  const hash = key.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return fallbackColors[hash % fallbackColors.length];
}

export default ScrumVelocityChart;
